import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/views/layout/Layout";

export const constantRouterMap = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/auth-redirect",
    component: () => import("@/views/login/authredirect"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    hidden: true
  },
  {
    path: "/401",
    component: () => import("@/views/errorPage/401"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    redirect: "dashboard",
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "Dashboard",
        meta: { title: "首页", icon: "dashboard", noCache: true }
      }
    ]
  }
];

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});

export const asyncRouterMap = [
  {
    path: "/clock",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "attendanceManage",
    meta: {
      title: "考勤管理",
      icon: "chart"
    },
    children: [
      {
        path: "attendance",
        component: () => import("@/views/attendance/clock"),
        name: "attendance",
        meta: {
          perms: [
            "GET /clock/list",
            "GET /clock/salary"
          ],
          title: "打卡记录",
          noCache: true
        }
      },
      {
        path: "overtime",
        component: () => import("@/views/attendance/overtime"),
        name: "overtime",
        meta: {
          perms: [
            "GET /clock/overtime/list",
            "POST /clock/overtime/approval"
          ],
          title: "加班记录",
          noCache: true
        }
      },
      {
        path: "leave",
        component: () => import("@/views/attendance/leave"),
        name: "leave",
        meta: {
          perms: [
            "GET /clock/absence/list",
            "POST /clock/absence/approval"
          ],
          title: "请假记录",
          noCache: true
        }
      },
    ]
  },
  {
    path: "/part",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "partManage",
    meta: {
      title: "配件管理",
      icon: "chart"
    },
    children: [
      {
        path: "battery",
        component: () => import("@/views/part/battery"),
        name: "battery",
        meta: {
          perms: [
            "GET /parts/battery/list",
            "POST /parts/battery/outbound",
            "POST /parts/battery/update",
            "GET /parts/battery/read",
            "POST /parts/battery/entry",
            "POST /parts/battery/returnEntry",
          ],
          title: "电池管理",
          noCache: true
        }
      },
      {
        path: "charger",
        component: () => import("@/views/part/charger"),
        name: "charger",
        meta: {
          perms: [
            "GET /parts/charger/list",
            "POST /parts/charger/outbound",
            "POST /parts/charger/update",
            "GET /parts/charger/read",
            "POST /parts/charger/entry",
            "POST /parts/charger/returnEntry",
          ],
          title: "充电器管理",
          noCache: true
        }
      },
      {
        path: "tyre",
        component: () => import("@/views/part/tyre"),
        name: "tyre",
        meta: {
          perms: [
            "GET /parts/tyre/list",
            "POST /parts/tyre/outbound",
            "POST /parts/tyre/update",
            "GET /parts/tyre/read",
            "POST /parts/tyre/entry",
            "POST /parts/tyre/returnEntry",
          ],
          title: "轮胎管理",
          noCache: true
        }
      },
      {
        path: "forklift",
        component: () => import("@/views/part/forklift"),
        name: "forklift",
        meta: {
          perms: [
            "GET /parts/forklift/list",
            "POST /parts/forklift/outbound",
            "POST /parts/forklift/update",
            "GET /parts/forklift/read",
            "POST /parts/forklift/entry",
            "POST /parts/forklift/returnEntry",
          ],
          title: "叉车配件管理",
          noCache: true
        }
      },
      {
        path: "common",
        component: () => import("@/views/part/common"),
        name: "common",
        meta: {
          perms: [
            "GET /parts/common/list",
            "POST /parts/common/outbound",
            "POST /parts/common/update",
            "GET /parts/common/read",
            "POST /parts/common/entry",
            "POST /parts/common/returnEntry",
          ],
          title: "通用配件管理",
          noCache: true
        }
      },
      {
        path: "partSetting",
        component: () => import("@/views/part/setting"),
        name: "partSetting",
        meta: {
          perms: [
            "GET /parts/setting/list",
            "POST /parts/setting/add",
            "POST /parts/setting/update",
            "POST /parts/setting/delete",
          ],
          title: "参数配置",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/personalPart",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "personalPartManage",
    meta: {
      title: "个人资产",
      icon: "chart"
    },
    children: [
      {
        path: "personalBattery",
        component: () => import("@/views/personalPart/personalBattery"),
        name: "personalBattery",
        meta: {
          perms: [
            "GET /parts/battery/list",
            "POST /parts/battery/outbound",
            "POST /parts/battery/update",
            "GET /parts/battery/read",
            "POST /parts/battery/entry",
            "POST /parts/battery/returnEntry",
          ],
          title: "电池管理",
          noCache: true
        }
      },
      {
        path: "personalCharger",
        component: () => import("@/views/personalPart/personalCharger"),
        name: "personalCharger",
        meta: {
          perms: [
            "GET /parts/charger/list",
            "POST /parts/charger/outbound",
            "POST /parts/charger/update",
            "GET /parts/charger/read",
            "POST /parts/charger/entry",
            "POST /parts/charger/returnEntry",
          ],
          title: "充电器管理",
          noCache: true
        }
      },
      {
        path: "personalTyre",
        component: () => import("@/views/personalPart/personalTyre"),
        name: "personalTyre",
        meta: {
          perms: [
            "GET /parts/tyre/list",
            "POST /parts/tyre/outbound",
            "POST /parts/tyre/update",
            "GET /parts/tyre/read",
            "POST /parts/tyre/entry",
            "POST /parts/tyre/returnEntry",
          ],
          title: "轮胎管理",
          noCache: true
        }
      },
      {
        path: "personalForklift",
        component: () => import("@/views/personalPart/personalForklift"),
        name: "personalForklift",
        meta: {
          perms: [
            "GET /parts/forklift/list",
            "POST /parts/forklift/outbound",
            "POST /parts/forklift/update",
            "GET /parts/forklift/read",
            "POST /parts/forklift/entry",
            "POST /parts/forklift/returnEntry",
          ],
          title: "叉车配件管理",
          noCache: true
        }
      },
      {
        path: "common",
        component: () => import("@/views/part/common"),
        name: "common",
        meta: {
          perms: [
            "GET /parts/common/list",
            "POST /parts/common/outbound",
            "POST /parts/common/update",
            "GET /parts/common/read",
            "POST /parts/common/entry",
            "POST /parts/common/returnEntry",
          ],
          title: "通用配件管理",
          noCache: true
        }
      },
      {
        path: "partSetting",
        component: () => import("@/views/part/setting"),
        name: "partSetting",
        meta: {
          perms: [
            "GET /parts/setting/list",
            "POST /parts/setting/add",
            "POST /parts/setting/update",
            "POST /parts/setting/delete",
          ],
          title: "参数配置",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/forklift",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "partManage",
    meta: {
      title: "叉车管理",
      icon: "chart"
    },
    children: [
      {
        path: "car",
        component: () => import("@/views/car/car"),
        name: "car",
        meta: {
          perms: [
            "GET /car/car/list",
            "POST /car/car/entry",
            "GET /car/car/read",
            "POST /car/car/update",
            "POST /car/car/outbound",
          ],
          title: "车辆管理",
          noCache: true
        }
      },
      {
        path: "mot",
        component: () => import("@/views/car/mot"),
        name: "mot",
        meta: {
          perms: [
            "GET /car/car/listMot",
            "POST /car/car/update",
            "POST /rent/doInspection",
          ],
          title: "待检车辆",
          noCache: true
        }
      },
      {
        path: "setting",
        component: () => import("@/views/car/setting"),
        name: "setting",
        meta: {
          perms: [
            "GET /parts/setting/list",
            "POST /parts/setting/add",
            "POST /parts/setting/update",
            "POST /parts/setting/delete",
          ],
          title: "参数配置",
          noCache: true
        }
      },
    ]
  },
  {
    path: "/rent",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "rent",
    meta: {
      title: "租赁管理",
      icon: "chart"
    },
    children: [
      {
        path: "rentCar",
        component: () => import("@/views/rent/car"),
        name: "rentCar",
        meta: {
          perms: [
            "GET /rent/listCar",
            "POST /rent/doRent",
            "POST /rent/doReturn",
            "POST /rent/doCancelRent",
            "POST /rent/doSale",
            "POST /rent/doScrape",
          ],
          title: "租赁管理",
          noCache: true
        }
      }, {
        path: "rentOrder",
        component: () => import("@/views/rent/order"),
        name: "rentOrder",
        meta: {
          perms: [
            "GET /rent/listRentOrder",
            "POST /rent/doConfirm",
          ],
          title: "租赁审批",
          noCache: true
        }
      }]
  },
  {
    path: "/maintenance",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "maintenance",
    meta: {
      title: "保养管理",
      icon: "chart"
    },
    children: [
      {
        path: "maintenanceList",
        component: () => import("@/views/maintenance/maintenanceList"),
        name: "maintenanceList",
        meta: {
          perms: [
            "GET /maintenance/list",
            "POST /maintenance/assign",
            "POST /maintenance/commit-log",
          ],
          title: "保养清单",
          noCache: true
        }
      }, {
        path: "maintenanceLogList",
        component: () => import("@/views/maintenance/maintenanceLogList"),
        name: "maintenanceLogList",
        meta: {
          perms: [
            "GET /maintenance/log-list",
            "POST /maintenance/confirm-price",
          ],
          title: "保养记录",
          noCache: true
        }
      }]
  },
  {
    path: "/repair",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "repair",
    meta: {
      title: "维修管理",
      icon: "chart"
    },
    children: [
      {
        path: "repairList",
        component: () => import("@/views/repair/repairList"),
        name: "repairList",
        meta: {
          perms: [
            "GET /repair/list",
            "POST /repair/assign",
            "POST /repair/report",
            "POST /repair/commit-log",
          ],
          title: "设备维修清单",
          noCache: true
        }
      }, {
        path: "repairLogList",
        component: () => import("@/views/repair/repairLogList"),
        name: "repairLogList",
        meta: {
          perms: [
            "GET /repair/log-list",
            "POST /repair/confirm-price",
          ],
          title: "设备维修记录",
          noCache: true
        }
      }, {
        path: "partRepairList",
        component: () => import("@/views/repair/partRepairLogList"),
        name: "partRepairList",
        meta: {
          perms: [
            "GET /partRepair/log-list",
            "POST /partRepair/confirm-price",
            "POST /partRepair/commit-log",
          ],
          title: "配件维修记录",
          noCache: true
        }
      }]
  },
  {
    path: "/stas",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "stas",
    meta: {
      title: "经营模块",
      icon: "chart"
    },
    children: [
      {
        path: "stasDashboard",
        component: () => import("@/views/stas/index"),
        name: "stasDashboard",
        meta: {
          perms: [
            "GET /costProfitOrder/info",
          ],
          title: "经营总览",
          noCache: true
        }
      },
      {
        path: "detailDashboard",
        component: () => import("@/views/stas/detailList"),
        name: "detailDashboard",
        meta: {
          perms: [
            "GET /costProfitOrder/listAllCostAndProfit",
          ],
          title: "叉车经营详情",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/costProfitOrder",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "costProfitOrder",
    meta: {
      title: "订单模块",
      icon: "chart"
    },
    children: [
      {
        path: "cost",
        component: () => import("@/views/costProfitOrder/cost"),
        name: "cost",
        meta: {
          perms: [
            "GET /costProfitOrder/listEntry",
            "GET /costProfitOrder/listScrapy",
            "GET /costProfitOrder/listInspection",
            "GET /costProfitOrder/listTransport",
            "GET /costProfitOrder/listRepairCost",
            "POST /costProfitOrder/doAuditCostProfitOrder",
          ],
          title: "成本订单",
          noCache: true
        }
      }, {
        path: "profit",
        component: () => import("@/views/costProfitOrder/profit"),
        name: "profit",
        meta: {
          perms: [
            "GET /costProfitOrder/listRepairProfit",
            "GET /costProfitOrder/listMaintenanceProfit",
            "GET /costProfitOrder/listRent",
            "GET /costProfitOrder/listSale",
            "POST /costProfitOrder/doAuditCostProfitOrder",
          ],
          title: "利润订单",
          noCache: true
        }
      }]
  },
  {
    path: "/costProfitOrderAccounting",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "costProfitOrderAccounting",
    meta: {
      title: "记账模块",
      icon: "chart"
    },
    children: [
      {
        path: "cost",
        component: () => import("@/views/costProfitOrderAccounting/cost"),
        name: "cost",
        meta: {
          perms: [
            "GET /costProfitOrder/listEntry",
            "GET /costProfitOrder/listScrapy",
            "GET /costProfitOrder/listInspection",
            "GET /costProfitOrder/listTransport",
            "GET /costProfitOrder/listRepairCost",
            "POST /costProfitOrder/doAuditCostProfitOrder",
          ],
          title: "成本订单",
          noCache: true
        }
      }, {
        path: "profit",
        component: () => import("@/views/costProfitOrderAccounting/profit"),
        name: "profit",
        meta: {
          perms: [
            "GET /costProfitOrder/listRepairProfit",
            "GET /costProfitOrder/listMaintenanceProfit",
            "GET /costProfitOrder/listRent",
            "GET /costProfitOrder/listSale",
            "POST /costProfitOrder/doAuditCostProfitOrder",
          ],
          title: "利润订单",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/bd",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "bdManage",
    meta: {
      title: "客户管理",
      icon: "chart"
    },
    children: [
      {
        path: "visit",
        component: () => import("@/views/bd/visit"),
        name: "visit",
        meta: {
          perms: [
            "POST /bd/visit/create",
            "POST /bd/visit/modify",
            "GET /bd/visit/list",
          ],
          title: "访客管理",
          noCache: true
        }
      }, {
        path: "company",
        component: () => import("@/views/bd/company"),
        name: "company",
        meta: {
          perms: [
            "POST /company/create",
            "POST /company/modify",
            "GET /bd/visit/list",
          ],
          title: "客户管理",
          noCache: true
        }
      }]
  },
  {
    path: "/transportOrder",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "transportOrder",
    meta: {
      title: "运输管理",
      icon: "chart"
    },
    children: [
      {
        path: "longTerm",
        component: () => import("@/views/transportOrder/longTerm"),
        name: "longTerm",
        meta: {
          perms: [
            "GET /transportOrder/list",
            "POST /transportOrder/create",
            "POST /transportOrder/update",
            "POST /transportOrder/aoAgree",
            "POST /transportOrder/delete",
          ],
          title: "长期合作商",
          noCache: true
        }
      }, {
        path: "thirdPart",
        component: () => import("@/views/transportOrder/thirdPart"),
        name: "thirdPart",
        meta: {
          perms: [
            "GET /transportOrder/list",
            "POST /transportOrder/create",
            "POST /transportOrder/update",
            "POST /transportOrder/aoAgree",
            "POST /transportOrder/delete",
          ],
          title: "第三方合作商",
          noCache: true
        }
      }]
  },
  {
    path: "/quote",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "quote",
    meta: {
      title: "报价管理",
      icon: "chart"
    },
    children: [
      {
        path: "quote",
        component: () => import("@/views/quote/quote"),
        name: "quote",
        meta: {
          perms: [
            "GET /quote/list",
            "POST /quote/create",
            "POST /quote/update",
            "POST /quote/delete",
          ],
          title: "报价管理",
          noCache: true
        }
      }]
  },
  {
    path: "/contract",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "contract",
    meta: {
      title: "合同管理",
      icon: "chart"
    },
    children: [
      {
        path: "contract",
        component: () => import("@/views/contract/contract"),
        name: "contract",
        meta: {
          perms: [
            "GET /contract/list",
            "GET /contract/listChild",
            "POST /contract/create",
            "POST /contract/update",
            "POST /contract/delete",
          ],
          title: "合同列表",
          noCache: true
        }
      },
      {
        path: "expireContract",
        component: () => import("@/views/contract/expireContract"),
        name: "expireContract",
        meta: {
          perms: [
            "GET /contract/listExpireContract",
          ],
          title: "到期合同",
          noCache: true
        }
      }]
  },
  {
    path: "/sys",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    name: "sysManage",
    meta: {
      title: "系统管理",
      icon: "chart"
    },
    children: [
      {
        path: "admin",
        component: () => import("@/views/sys/admin"),
        name: "admin",
        meta: {
          perms: [
            "GET /admin/admin/list",
            "POST /admin/admin/create",
            "POST /admin/admin/update",
            "POST /admin/admin/delete"
          ],
          title: "系统用户管理",
          noCache: true
        }
      },
      {
        path: "role",
        component: () => import("@/views/sys/role"),
        name: "role",
        meta: {
          perms: [
            "GET /admin/role/list",
            "POST /admin/role/create",
            "POST /admin/role/update",
            "POST /admin/role/delete",
            "GET /admin/role/permissions",
            "POST /admin/role/permissions"
          ],
          title: "角色管理",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/profile",
    component: Layout,
    redirect: "noredirect",
    alwaysShow: true,
    children: [
      {
        path: "password",
        component: () => import("@/views/profile/password"),
        name: "password",
        meta: { title: "修改密码", noCache: true }
      }
    ],
    hidden: true
  },
  { path: "*", redirect: "/404", hidden: true }
];
